<template>
    <div>
        <div class="container-fluid">
            <div class="success_message" v-text="this.$root.success_message" v-if="this.$root.success_message != ''">
            </div>
            <div class="error_message" v-text="this.$root.error_message" v-if="this.$root.error_message != ''"></div>
            <div class="row">
                <div class="col-12" v-if="this.thankyou_page === false">
                    <div class="content-pages">
                        <h2 class="page-title">Contact us</h2>
                        <div class="row">
                            <div class="col-12" v-if="this.$root.store === 1">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d9915.954732874008!2d77.17428917514228!3d28.515080371465068!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x7b24d68470c4e08!2sW+for+Woman!5e0!3m2!1sen!2sin!4v1556621857159!5m2!1sen!2sin"
                                    width="100%" height="350" class="contact-map"></iframe>
                            </div>
                            <div class="col-md-6 col-12">
                                <h5 class="content-section-heading">Write Us</h5>
                                <p>Jot us a note and we’ll get back to you as quickly as possible.</p>
                                <form class="contact-form">
                                    <div class="row">
                                        <div class="field full-name col-12">
                                            <input class="input-text form-control"
                                                v-bind:class="{success : this.name_error == '', error : this.name_error != ' '}"
                                                v-model="user.name" placeholder="Name*" autocomplete="off"
                                                @keyup="user_name" type="text" name="full_name" required="">
                                            <p class="size_error" v-text="this.name_error"></p>
                                        </div>
                                        <div class="field email col-md-6 col-12">
                                            <input class="input-text form-control" type="email"
                                                v-bind:class="{success : this.email_error == '', error : this.email_error != ' '}"
                                                placeholder="Email*" autocomplete="off" @keyup="user_email"
                                                v-model="user.email" name="Email" required="">
                                            <p class="size_error" v-text="this.email_error"></p>
                                        </div>
                                        <div class="field receiver-phone col-md-6 col-12">
                                            <input class="input-text form-control" placeholder="Phone*"
                                                v-bind:class="{success : this.phone_error == '', error : this.phone_error != ' '}"
                                                maxlength="10" autocomplete="off" @keyup="user_phone"
                                                v-model="user.phone" type="text" name="phone" required="">
                                            <p class="size_error" v-text="this.phone_error"></p>
                                        </div>
                                        <div class="col-12">
                                            <p>What can we help you with:</p>
                                        </div>
                                        <div class="field col-md-6 col-12">
                                            <select class="input-text form-control" @change="user_category"
                                                v-bind:class="{success : this.category_error == '', error : this.category_error != ' '}"
                                                name="category" v-model="user.category">
                                                <option value=""> -Browse All Topics*- </option>
                                                <option value="return">Return</option>
                                                <option value="refund">Refund</option>
                                                <option value="cancel">Cancel</option>
                                                <option value="order-status">Order Status</option>
                                                <option value="reverse-pickup">Reverse Pickup</option>
                                                <option value="rewards-promotions">Rewards Promotions</option>
                                                <option value="corporate-enquiry">Corporate Enquiry</option>
                                                <option value="others">Others</option>
                                            </select>
                                            <p class="size_error" v-text="this.category_error"></p>
                                        </div>
                                        <div class="field col-md-6 col-12">
                                            <select class="input-text form-control" @change="user_reason" name="reason"
                                                :disabled="this.reason_dis === true"
                                                v-bind:class="{success : this.reason_error == '', error : this.reason_error != ' '}"
                                                v-model="user.reason">
                                                <option value=""> -Reason*- </option>
                                                <option value="quality">Quality</option>
                                                <option value="size">Size</option>
                                                <option value="wrong-article">Wrong Article</option>
                                                <option value="others" selected="selected">Others</option>
                                            </select>
                                            <p class="size_error" v-text="this.reason_error"></p>
                                        </div>
                                        <div class="field col-12" v-if="orderreq">
                                            <input class="input-text form-control" v-model="user.order_no"
                                                :disabled="this.order_dis === true" @keyup="user_order_no"
                                                v-bind:class="{success : this.order_no_error == '', error : this.order_no_error != ' '}"
                                                placeholder="Order number*" type="text" required="">
                                            <p class="size_error" v-text="this.order_no_error"></p>
                                        </div>
                                        <div class="field col-md-12 col-12">
                                            <textarea name="comment" placeholder="Comments*" v-model="user.comments"
                                                @keyup="user_comments"
                                                v-bind:class="{success : this.comments_error == '', error : this.comments_error != ' '}"
                                                class="input-text form-control" cols="5" rows="3"></textarea>
                                            <p class="size_error" v-text="this.comments_error"></p>
                                        </div>
                                        <div class="field col-md-6 col-12">
                                            <VueRecaptcha v-if="recaptchaload==true" ref="recaptcha"
                                                @verify="onCaptchaVerified" @expired="onCaptchaExpired"
                                                :sitekey="siteKey"></VueRecaptcha>
                                        </div>
                                        <div class="field submit col-12">
                                            <button type="button" @click="contact_submit" v-ripple
                                                class="pull-right contact-submit">
                                                <span>Submit</span>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="col-md-6 col-12" >
                                <h5 class="content-section-heading">Address</h5>
                                <p>
                                    <b>Sakarashop Online Private Limited</b><br>
                                    <b>Registered Office Address :</b>  #845, 10th main, 5th cross,<br>
									Indiranagar 2nd stage,<br>
									Bangalore - 560 038<br>
									India,<br>
                                    <!-- Neelagagan towers,<br>  -->
                                    <!-- <strong>Web : </strong><a href="/">www.wforwoman.com</a><br> -->
                                    <strong>Mail : </strong><a
                                        href="mailto:customercare@wndw.in">customercare@wndw.in</a><br>
                                    Reach us on <a href="tel:+91 9513316696">+91 9513316696</a> from 9 AM to 9 PM
                                </p>
								<!-- <p>
                                    <b>Operating Office Address :</b> ##845, 10th main, 5th cross,<br>
									Indiranagar 2nd stage,<br>
									Bangalore - 560 038<br>
									India,<br> 
                                    
                                </p> -->
                            </div>
                             
                        </div>
                    </div>

                </div>
                <div class="col-12" v-else>
                    <div class="content-pages">
                        <div class="thanks_page p-5 text-center">
                            <h2>Thank you for contacting us!</h2>
                            <p>Your comments and questions will respond to you very soon.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
		<div
      class="modal"
      style="z-index: 1100"
      v-bind:class="[this.contact_process ? 'active' : '']"
      id="coupon-modal"
    >
      <loading-icon
        class="loading-icon contactloader"
        name="ball-clip-rotate-multiple"
        color="#ba2126"
        scale="1"
      ></loading-icon>
    </div>
        <!-- <div class="modal select-lens-popup account-login" :class="{active:this.otp_popup==true}" v-if="this.otp_popup==true">
            <div class="over-flow"></div>
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="text-center">Please enter the OTP sent on your mobile</h3>
                        <button type="button" class="close" @click="otp_popup=false,otp_number=''">×</button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <div class="col-md-12 col-sm-12 col-xs-12 checkout-section">
                                <div id="login-section" class="login-section opc-section">
                                    <form class="login-form">
                                        <div class="field otp">
                                            <input maxlength="4" v-model="otp_number" placeholder="OTP*" type="text"
                                                name="customerpassword" autocomplete="off"
                                                class="input-text form-control">
                                            <p class="otp_error" style="font-size: 14px;color:red;margin-top:5px">{{this.otp_error}}</p>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
    
    </div>
</template>

<script>
	import axios from "axios";
	import VueRecaptcha from "vue-recaptcha";
	export default {
		name: "contact_us",
		metaInfo() {
			return {
				title: this.meta_title,
				meta: [
					{
						name: "description",
						content: this.meta_description,
					},
					{
						property: "keywords",
						content: this.meta_keyword,
					},
				],
			};
		},
		components: {
			VueRecaptcha,
		},
		data() { 
			return {
				orderreq:true,
				contact_process:false,
				siteKey: (location.host === 'wndw.in' || location.host === 'www.wndw.in') ? '6LcD6oQbAAAAANTy1zMkdjPlCZFsrbQ9KGlbKLKN' : '6Lea4oQbAAAAAL03xS0xg4H7n4kRASD9OCyNjHeO',
				recaptchaload: false,
				meta_title: "",
				meta_description: "",
				meta_keyword: "",
				name_error: " ",
				email_error: " ",
				phone_error: " ",
				category_error: " ",
				reason_error: " ",
				order_no_error: " ",
				comments_error: " ",
				reason_dis: false,
				order_dis: false,
				thankyou_page: false,
				user: {
					name: "",
					email: "",
					phone: "",
					category: "",
					reason: "",
					order_no: "",
					comments: "",
					captcha: "",
				},
				// otp_popup: false,
				// otp_number: "",
				// otp_error: "",
			};
		},
		methods: {
			get_account: function () {
				
				if (this.$root.customer_id != null && this.$root.customer_id != "") {
					
					this.$root.error_message = "";
					this.$root.success_message = "";
					var form = new FormData();
					form.append("customer_id", this.$root.customer_id);
					form.append("customer_session", this.$root.customer_session);
					form.append("store", this.$root.store);
					axios.post(this.$root.cart_api + "/customer/account-details", form)
						.then((response) => {
							if (response.data.success === true) {
									console.log("test",response)
									this.user.email=response.data.data.email
									this.user.phone=response.data.data.phone
							} 
						})
						.catch(error => {
                           console.log(error)
                        });
				}
			},
			onCaptchaExpired: function () {
				this.$refs.recaptcha.reset();
				this.user.captcha = "";
			},
			onCaptchaVerified: function (recaptchaToken) {
				this.user.captcha = recaptchaToken;
			},
			user_order_no: function () {
				var order = /^([a-zA-Z0-9])+$/;
				if (this.user.order_no.match(order)) {
					this.order_no_error = "";
				} else {
					this.order_no_error = "Please enter valid Order Number";
				}
			},
			user_comments: function () {
				var comments = /^([^\s]+[a-z ,A-Z, ])+$/;
				if (this.user.comments.match(comments)) {
					this.comments_error = "";
				} else {
					this.comments_error = "Please enter valid Comments";
				}
			},
			user_name: function () {
				var name = /^([^\s]+[a-z ,A-Z, ])+$/;
				if (this.user.name.match(name)) {
					this.name_error = "";
				} else {
					this.name_error = "Please enter Name";
				}
			},
			user_email: function () {
				var email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				if (this.user.email.match(email)) {
					this.email_error = "";
				} else {
					this.email_error = "Please enter valid Email";
				}
			},
			user_category: function () {
				if (this.user.category != "") {
					if (this.user.category === "others") {
						this.reason_dis = true;
						this.order_dis = true;
						this.order_dis=false;
						this.user.reason = "others";
						this.user.order_no = "Null";
						this.order_no_error=''
						this.orderreq=false
						// this.user.order_no = "";
						this.user_reason();
						this.user_order_no();
					} 
					else if (
						this.user.category === "corporate-enquiry" ||
						this.user.category === "rewards-promotions"
					
					) {
						this.orderreq=false
						this.user.order_no = "Null";
						this.order_no_error=''
						this.reason_dis = true;
						this.user.reason = "others";
						this.user_reason();
					} 
					else if (
						this.user.category === "order-status"
					) {
						this.reason_dis = true;
						this.user.reason = "others";
						this.orderreq=true
						this.user_reason();
					} 
					else {
						this.reason_dis = false;
						this.order_dis = false;
						this.orderreq=true
						this.user.reason = "";
						this.user.order_no = "";
						this.user_reason();
						this.user_order_no();
					}

					this.category_error = "";
				} else {
					this.category_error = "Please select valid Category";
				}
			},
			user_reason: function () {
				this.recaptchaload = true;
				if (this.user.reason != "") {
					this.reason_error = "";
				} else {
					this.reason_error = "Please select valid Reason";
				}
			},
			user_phone: function () {
				var phoneno = /^([0-9]{10,})+$/;
				if (this.user.phone.match(phoneno)) {
					this.phone_error = "";
				} else {
					this.phone_error = "Please enter valid Phone Number";
				}
			},
			contact_submit: function () {
		
				
				if (
					this.user.name != "" &&
					this.user.email != "" &&
					this.user.phone != "" &&
					this.user.Reason != "" &&
					this.user.order_no != "" &&
					this.user.comments != "" &&
					this.user.category != "" &&
					this.name_error == "" &&
					this.email_error == "" &&
					this.phone_error == "" &&
					this.order_no_error == "" &&
					this.category_error == "" &&
					this.reason_error == "" &&
					this.comments_error == ""
				) {
					this.$root.page_loader = true;
					if (this.user.captcha != "") {
						this.contact_process = true;	
						// if (this.otp_number != "") {
							var form = new FormData();
							form.append("name", this.user.name);
							form.append("full_name", this.user.name);
							form.append("email", this.user.email);
							form.append("pin_code", this.user.pin_code);
							form.append("phone", this.user.phone);
							form.append("topic", this.user.category);
							form.append("reason", this.user.reason);
							form.append("order", this.user.order_no);
							form.append("comment", this.user.comments);
							form.append("captcha", this.user.captcha);
							axios
								.post(this.$root.cart_api + "/contact", form)
								.then((response) => {
									if (response.data.success === true) {
										// this.otp_popup = false;
										// this.otp_number = "";
										this.contact_process = false;	
										this.$root.page_loader = false;
										this.$root.success_message = response.data.message;
										this.$root.error_message = "";
										this.thankyou_page = true;
										window.scrollTo(0,0)
									} else {
										this.$root.error_message = response.data.message;
										this.$root.success_message = "";
										this.$root.page_loader = false;
										window.scrollTo(0,0)
									}
								})
								.catch((error) => {
									this.$root.page_loader = false;
									this.contact_process = false;	
									if (error.message === "Network Error") {
										this.$toast.error(
											"Oops there seems to be some Network issue, please try again.",
											{
												position: "top",
												duration: 4000,
											}
										);
									}
									window.scrollTo(0,0)
								});
						// } else {
						// 	var form = new FormData();
						// 	form.append("phone", this.user.phone);
						// 	let config = { headers: { "Content-Type": "multipart/form-data" } };
						// 	axios
						// 		.post(this.$root.cart_api + "/sendc-otp", form, config)
						// 		.then((response) => {
						// 			if (response.data.success === true) {
						// 				this.$root.page_loader = false;
						// 				this.otp_popup = true;
						// 				this.$toast.success(response.data.message, {
						// 					position: "top",
						// 					duration: 4000,
						// 				});
						// 			} else {
						// 				this.$root.page_loader = false;
						// 				this.$toast.error(response.data.message, {
						// 					position: "top",
						// 					duration: 4000,
						// 				});
						// 			}
						// 		});
						// }
					} else {
						this.$root.page_loader = false;
						this.$toast.error("Please verify Google captcha", {
							position: "top",
							duration: 4000,
						});
					}
				} else {
					this.$root.page_loader = false;
					this.user_name();
					this.user_order_no();
					this.user_email();
					this.user_phone();
					this.user_comments();
					this.user_category();
					this.user_reason();
				}
			},
		},
		created() {
			
			this.get_account();
			window.scrollTo(0, 0);
			this.$root.breadcrumb = "Contact Us";
			if (this.$root.store === 1) {
				this.meta_title = "Contact Us";
				// this.meta_description =
				// 	"Online fashion shopping destination for the modern women. Buy latest collection of online ethnic wear for women, W Kurtas, dresses, bottom wear, tops, palazzos, culottes, skirts, drapes and more.";
				// this.meta_keyword = "Online Shopping for Women,  W for Woman";
			} else {
				this.meta_title = "Have a Query? Get In Touch With Us";
				// this.meta_description =
				// 	"Have a question? Please share your queries and our team will respond to you very soon.";
				// this.meta_keyword = "contact Aurelia";
			}
		},
		watch: {
			// otp_number: {
			// 	handler: function (after, before) {
			// 		var otpno = /^\d*(?:\.\d{1,2})?$/;
			// 		if (this.otp_number.match(otpno)) {
			// 			this.otp_error = "";
			// 			if (this.otp_number.length == "4") {
			// 				this.$root.page_loader = true;
			// 				var form = new FormData();
			// 				form.append("phone", this.user.phone);
			// 				form.append("otp", this.otp_number);
			// 				let config = { headers: { "Content-Type": "multipart/form-data" } };
			// 				axios
			// 					.post(this.$root.cart_api + "/vaildate", form, config)
			// 					.then((response) => {
			// 						if (response.data.success === true) {
			// 							this.contact_submit();
			// 							this.$toast.success(response.data.message, {
			// 								position: "top",
			// 								duration: 4000,
			// 							});
			// 						} else {
			// 							this.$root.page_loader = false;
			// 							this.$toast.error(response.data.message, {
			// 								position: "top",
			// 								duration: 4000,
			// 							});
			// 						}
			// 					})
			// 					.catch((error) => {
			// 						this.$root.page_loader = false;
			// 						if (error.message === "Network Error") {
			// 							this.$toast.error(
			// 								"Oops there seems to be some Network issue, please try again.",
			// 								{
			// 									position: "top",
			// 									duration: 4000,
			// 								}
			// 							);
			// 						}
			// 					});
			// 			}
			// 		} else {
			// 			this.otp = false;
			// 			this.otp_error = "Please enter valid OTP";
			// 		}
			// 	},
			// },
		},
	};
</script>

<style scoped>
.contactloader {
  position: relative;
  top: 50%;
  left: 50%;
}
</style>